var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSgd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2674C0 5.63996 5.37262 0.267334 12 0.267334C18.6274 0.267334 24 5.63996 24 12.2674",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30353 6.52883C7.30353 4.78049 8.53226 3.31996 10.1731 2.9616C9.92089 2.90657 9.65928 2.87671 9.39045 2.87671C7.37337 2.87671 5.73828 4.5118 5.73828 6.52888C5.73828 8.54596 7.37337 10.1811 9.39045 10.1811C9.65919 10.1811 9.92084 10.1512 10.1731 10.0961C8.53226 9.73776 7.30353 8.27723 7.30353 6.52883Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 3.13843L12.2585 3.93554H13.0967L12.4186 4.42824L12.6776 5.22535L11.9995 4.73274L11.3214 5.22535L11.5804 4.42824L10.9023 3.93554H11.7405L11.9995 3.13843Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96639 4.70093L10.2254 5.49808H11.0635L10.3855 5.99074L10.6445 6.78785L9.96639 6.29524L9.2882 6.78785L9.54728 5.99074L8.86914 5.49808H9.70731L9.96639 4.70093Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0327 4.70093L14.2918 5.49808H15.1299L14.4518 5.99074L14.7108 6.78785L14.0327 6.29524L13.3546 6.78785L13.6136 5.99074L12.9355 5.49808H13.7737L14.0327 4.70093Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2495 7.05249L13.5085 7.84965H14.3467L13.6686 8.3423L13.9276 9.13941L13.2495 8.6468L12.5714 9.13941L12.8304 8.3423L12.1523 7.84965H12.9904L13.2495 7.05249Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7476 7.05249L11.0066 7.84965H11.8448L11.1667 8.3423L11.4257 9.13941L10.7476 8.6468L10.0695 9.13941L10.3285 8.3423L9.65039 7.84965H10.4886L10.7476 7.05249Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSgd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SGD.5f77ab7692ca990dbd9051358827f37e.svg";